import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  Modal,
  HelperViewStatus,
  Heading,
  BaseText,
  ListDisplay,
  ButtonSecondary,
  ButtonContainer
} from '@warrenbrasil/nebraska-web';
import {
  IOrderProduct,
  EOrderStatus,
  EOrderButtonAction
} from '@/modules/wealth/services/portfolio-orders';

interface Props {
  isOpen: boolean;
  product: IOrderProduct | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailsModal',
  props: {
    isOpen: { type: Boolean },
    product: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  product: IOrderProduct | null;
};

const router = useRouter();



const productDetails = computed(() => {
  return props.product?.details;
});

function handleButtonAction(action: string) {
  if (action === EOrderButtonAction.OPEN_TRANSIT) {
    navigateToTransactions();
  }
}

function navigateToTransactions() {
  router.push({
    path: '/transactions',
    query: { filter: 'future_transactions' }
  });
}

return { __sfc: true,router, props, productDetails, handleButtonAction, navigateToTransactions, Modal, HelperViewStatus, Heading, BaseText, ListDisplay, ButtonSecondary, ButtonContainer, EOrderStatus }
}

})